import { spreadsData } from "../../../api/data/spreads";
import type { SpreadReadingProfile } from "../types";
import { oneCardReadingProfile } from "./oneCard";
import { twoCardsReadingProfile } from "./twoCards";
import { threeCardsReadingProfile } from "./threeCards";
import { celticCrossReadingProfile } from "./celticCross";
import { crossChoiceReadingProfile } from "./crossChoice";
import { choicePathReadingProfile } from "./choicePath";
import { treeOfLifeReadingProfile } from "./treeOfLife";
import { psychologicalCircleReadingProfile } from "./psychologicalCircle";
import { psychologicalLifeProfileReadingProfile } from "./psychologicalLifeProfile";
import { relationshipsReadingProfile } from "./relationships";
import { situationPotentialReadingProfile } from "./situationPotential";
import { situationDevelopmentReadingProfile } from "./situationDevelopment";
import { periodicForecastReadingProfile } from "./periodicForecast";
import { yearlyReadingProfile } from "./yearly";

const readingProfiles: SpreadReadingProfile[] = [
  oneCardReadingProfile,
  twoCardsReadingProfile,
  threeCardsReadingProfile,
  celticCrossReadingProfile,
  crossChoiceReadingProfile,
  choicePathReadingProfile,
  treeOfLifeReadingProfile,
  psychologicalCircleReadingProfile,
  psychologicalLifeProfileReadingProfile,
  relationshipsReadingProfile,
  situationPotentialReadingProfile,
  situationDevelopmentReadingProfile,
  periodicForecastReadingProfile,
  yearlyReadingProfile,
];

const validateReadingProfiles = (
  profiles: SpreadReadingProfile[]
): void => {
  const spreadsById = new Map(
    spreadsData.map((spread) => [
      spread.id,
      spread,
    ])
  );

  const profileIds = new Set<string>();

  profiles.forEach((profile) => {
    const profileId = profile.spreadId.trim();

    if (!profileId) {
      throw new Error(
        "Обнаружен reading profile без spreadId"
      );
    }

    if (profileIds.has(profileId)) {
      throw new Error(
        `Повторяющийся reading profile для spreadId "${profileId}"`
      );
    }

    profileIds.add(profileId);

    const spread = spreadsById.get(profileId);

    if (!spread) {
      throw new Error(
        `Reading profile ссылается на несуществующий spreadId "${profileId}"`
      );
    }

    const positionIds = new Set(
      spread.positions.map(
        (position) => position.id
      )
    );

    Object.keys(
      profile.positionOverrides ?? {}
    ).forEach((positionId) => {
      if (!positionIds.has(positionId)) {
        throw new Error(
          `Reading profile "${profileId}" содержит override ` +
            `для несуществующей позиции "${positionId}"`
        );
      }
    });
  });

  spreadsData.forEach((spread) => {
    if (!profileIds.has(spread.id)) {
      throw new Error(
        `Для расклада "${spread.id}" отсутствует reading profile`
      );
    }
  });
};

validateReadingProfiles(readingProfiles);

const profiles = readingProfiles.reduce<
  Record<string, SpreadReadingProfile>
>((registry, profile) => {
  registry[profile.spreadId] = profile;
  return registry;
}, {});

export const getReadingProfile = (
  spreadId: string
): SpreadReadingProfile => {
  const profile = profiles[spreadId];

  if (!profile) {
    throw new Error(
      `Reading profile для расклада "${spreadId}" не найден`
    );
  }

  return profile;
};
